export default "__VITE_ASSET__DDaA7E6a__"